// src/data/gyms/Lightning.js
export const Lightning = {
  id: "lightning",
  name: "Lightning All-Stars",
  color: "#1D4ED8", // Electric Blue
  lightColor: "#EFF6FF",
  logo: "⚡️",

  teams: [
    {
      id: "silversmoke",
      name: "Silver Smoke",
      level: "L2 Junior - D2 - Small",
    },
    { id: "threeclipse", name: "3clipse", level: "L3 Senior - D2" },
    { id: "storm", name: "Storm", level: "L1 Junior - D2" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "11:14 AM",
      teamId: "silversmoke",
      meet: "10:38 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "1:44 PM",
      teamId: "threeclipse",
      meet: "1:08 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "2:33 PM",
      teamId: "storm",
      meet: "1:57 PM",
      panel: "Hall A",
    },

    // ================= SUNDAY (Dec 14) =================
    {
      day: "Sunday",
      time: "9:17 AM",
      teamId: "silversmoke",
      meet: "8:41 AM",
      panel: "Hall B",
    },
    {
      day: "Sunday",
      time: "10:52 AM",
      teamId: "threeclipse",
      meet: "10:16 AM",
      panel: "Hall A",
    },
    // Found in PDF Row 190
    {
      day: "Sunday",
      time: "12:14 PM",
      teamId: "storm",
      meet: "11:38 AM",
      panel: "Hall A",
    },
  ],
};
